<template>
  <div>
    <section>
      <v-container container--fluid grid-list-md>
        <v-row>
          <v-col cols="12">
            <h1>Regions</h1>
          </v-col>
        </v-row>

        <v-row justify="space-between" :class="{'flex-column': $vuetify.breakpoint.smAndDown}">
          <v-col cols="12" sm="12" md="3">
            <v-text-field label="Search..." v-model="search" prepend-icon="search"></v-text-field>
          </v-col>

          <v-col cols="12" sm="12" md="1" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn text large @click="updateDataTable" v-on="on">
                  <v-icon color="cyan darken-2">refresh</v-icon>
                </v-btn>
              </template>
              <span>Refresh</span>
            </v-tooltip>
          </v-col>

          <v-col cols="12" sm="12" md="2" class="text-center">
            <v-tooltip top color="secondary">
              <template v-slot:activator="{ on }">
                <v-btn @click="newRegion" class="mx-2" fab dark color="blue lighten-1" v-on="on">
                  <v-icon dark>add</v-icon>
                </v-btn>
              </template>
              <span>Create a new region</span>
            </v-tooltip>
          </v-col>

        </v-row>
      </v-container>
      <v-divider></v-divider>

      <v-data-table
        :search="search"
        :headers="headers"
        :items="renderedRegions"
        :loading="loading"
      >
        <template v-slot:item="props">
          <tr v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
            <td v-if="header.text !== 'Actions'" style="text-align: center" v-for="(header, index) in headers"
                :key="index">{{props.item[header.value]}}
            </td>
            <td v-else class="text-center">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-icon @click="editRow(props.item)" color="blue" v-on="on">
                    edit
                  </v-icon>
                </template>
                <span>Edit</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </section>

    <v-dialog
      v-model="regionsDialog"
      max-width="400px"
    >
      <v-card>
        <v-card-title>
          <h3>{{editedIndex > -1 ? 'Edit Region ' + regionItem.id : 'New region' }}</h3>
        </v-card-title>
        <v-card-text>
          <v-text-field
            v-model="regionItem.name"
            label="Name"
            prepend-icon="fas fa-map-marked-alt"
          ></v-text-field>
          <v-text-field
            v-model="regionItem.ops_email"
            label="OPS email"
            prepend-icon="fas fa-envelope"
            :rules="emailRule"
          ></v-text-field>
          <v-text-field
            v-model="regionItem.oracle_distribution_centre"
            label="Oracle Distribution Centre"
            prepend-icon="fas fa-database"
          ></v-text-field>
          <v-select
            label="Choose a timezone"
            :items="timezoneItems"
            v-model="regionItem.timezone"
            prepend-icon="access_time"
          ></v-select>
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn
            text
            @click="closeRegionsDialog"
            color="blue-grey lighten-2"
          >Cancel
          </v-btn>
          <v-btn
            text
            @click="saveChanges"
            color="blue darken-1"
          >Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="deleteDialog"
      max-width="500px"
    >
      <v-card>
        <v-card-title class="justify-center">
          <h3>ATTENTION</h3>
        </v-card-title>
        <v-card-text class="text-center">
          You are about to delete this region. This action cannot be undone. <br>
          Are you sure you want to proceed ?
        </v-card-text>
        <v-card-actions class="justify-center">
          <v-btn text @click="toBeDeleted=null; deleteDialog=false" color="blue-grey lighten-2">No</v-btn>
          <v-btn text @click="deleteRegion" color="blue darken-1">Yes</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
    import axios from 'axios';

    export default {
        name: "ManageRegions",
        data() {
            return {
                search: '',
                loading: false,
                reload: false,
                timer: '',
                headers: [
                    {text: 'Id', value: 'id', align: 'center', sortable: true},
                    {text: 'Name', value: 'name', align: 'center', sortable: true},
                    {text: 'Code', value: 'code', align: 'center', sortable: true},
                    {text: 'Ops email', value: 'ops_email', align: 'center', sortable: true},
                    {
                        text: 'Oracle',
                        value: 'oracle_distribution_centre',
                        align: 'center',
                        sortable: true
                    },
                    {text: 'Timezone', value: 'timezone', align: 'center', sortable: true},
                    {text: 'Is agent ?', value: 'is_agent', align: 'center', sortable: true},
                    {text: 'Actions', value: 'actions', align: 'center', sortable: false}
                ],
                timezoneItems: [
                    {text: "Australia/Adelaide", value: 'Australia/Adelaide'},
                    {text: "Australia/Brisbane", value: 'Australia/Brisbane'},
                    {text: "Australia/Broken_Hill", value: 'Australia/Broken_Hill'},
                    {text: "Australia/Currie", value: 'Australia/Currie'},
                    {text: "Australia/Darwin", value: 'Australia/Darwin'},
                    {text: "Australia/Eucla", value: 'Australia/Eucla'},
                    {text: "Australia/Hobart", value: 'Australia/Hobart'},
                    {text: "Australia/Lindeman", value: 'Australia/Lindeman'},
                    {text: "Australia/Melbourne", value: 'Australia/Melbourne'},
                    {text: "Australia/Perth", value: 'Australia/Perth'},
                    {text: "Australia/Sydney", value: 'Australia/Sydney'},
                ],
                regionsDialog: false,
                editedIndex: -1,
                toBeDeleted: null,
                deleteDialog: false,
                regionItem: {
                    name: null,
                    ops_email: null,
                    oracle_distribution_centre: null,
                    timezone: null,
                },
                default: {
                    name: null,
                    ops_email: null,
                    oracle_distribution_centre: null,
                    timezone: null,
                },
                emailRule: [
                    v => !!v || 'This field is required',
                    v => /.+@.+/.test(v) || 'E-mail must be valid'
                ],
            }
        },
        mounted: function () {
            this.timer = setInterval(() => {
                this.reload = !this.reload;
            }, 300000)
        },
        beforeDestroy() {
            clearInterval(this.timer)
        },
        computed: {
            renderedRegions() {
                if (this.Regions === null || this.Regions === undefined) {
                    return [];
                } else {
                    return this.Regions;
                }
            },
        },
        asyncComputed: {
            async Regions() {
                if (this.reload || !this.reload) {
                    this.loading = true;
                    return await axios.get(process.env.API_URL + '/regions')
                        .then((response) => {
                            if (response.status === 200) {
                                this.loading = false;
                                return response.data;
                            } else {
                                this.loading = false;
                                return [];
                            }
                        })
                        .catch((error) => {
                            this.loading = false;
                            return [];
                        });
                }
            }
        },
        methods: {
            updateDataTable() {
                this.reload = !this.reload;
            },
            newRegion() {
                this.editedIndex = -1;
                this.regionItem = Object.assign({}, this.default);
                this.regionsDialog = true;
            },
            editRow(item) {
                this.editedIndex = this.Regions.indexOf(item);
                this.regionItem = Object.assign({}, item);
                this.regionsDialog = true;
            },
            closeRegionsDialog() {
                this.regionsDialog = false;
                this.editedIndex = -1;
            },
            saveChanges() {
                let body = this.regionItem;

                if (this.editedIndex > -1) {
                    axios.put(process.env.API_URL + '/regions/' + this.regionItem.id, body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', "Changes saved");
                            this.updateDataTable();
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                        })
                } else {
                    if (body.name === null) {
                        this.$store.commit('displaySnackbar', 'Please select a name for the region');
                        return false;
                    }

                    axios.post(process.env.API_URL + '/regions', body)
                        .then((response) => {
                            this.$store.commit('displaySnackbar', 'Create successful');
                            this.updateDataTable();
                        })
                        .catch((response) => {
                            this.$store.commit('displaySnackbar', 'ERROR: Create failed');
                        })
                }
                this.closeRegionsDialog();
            },
            deleteRow(item) {
                this.toBeDeleted = item;
                this.deleteDialog = true;
            },
            deleteRegion() {
                let index = this.Regions.indexOf(this.toBeDeleted);
                axios.delete(process.env.API_URL + '/regions/' + this.toBeDeleted.id)
                    .then((response) => {
                        this.$store.commit('displaySnackbar', 'Detete successful');
                        this.Depots.splice(index, 1);
                        this.deleteDialog = false;
                        this.updateDataTable();
                    })
                    .catch((response) => {
                        this.$store.commit('displaySnackbar', 'ERROR ' + response.response.data.error);
                    })
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/Admin/GlobalAdmin/ManageRegions.vue